import { useEffect } from "react"
import { useNavigate } from "react-router"

export default function TechPage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate("/dashboard/gate2")
  }, [navigate])

  return null
}
